import React, { useEffect } from "react";
import "../../../styles/verifiedNavigation.css";
import { FaStore, FaHome } from "react-icons/fa";
import {
  IoBag,
  IoNotifications,
  IoReceiptSharp,
  IoShirt,
  IoTime,
} from "react-icons/io5";
import { VscGraph } from "react-icons/vsc";
import { IoIosSettings } from "react-icons/io";
import { BiSupport } from "react-icons/bi";
import { RiLogoutBoxFill } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import shophrLogo from "../../../assets/IMGS/shophrLogo.PNG";
import { AuthServices } from "../../auth/services/AuthServices";

const VerifiedNavigation = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const handleLogout = async () => {
    const response = await AuthServices.clearToken();

    if (response.status !== 200) {
      console.error("There was an error logging out:", response);
      return;
    }
    
    navigate("/");
  };

  const authenticateUser = async () => {
    const response = await AuthServices.fetchProfile();
    if (response.data?.status === 401) {
      navigate("/");
      return;
    }
  };

  useEffect(() => {
    authenticateUser();
  }, []);

  return (
    <header className="verified-navigation">
      <nav className="verified-nav-bar">
        <ul className="verified-nav-links">
          <div className="verified-nav-links-top">
            <img src={shophrLogo ? shophrLogo : null} alt="shophr logo" />
            <Link to="/manager/dashboard">
              <li>
                <FaHome size={17} />
              </li>
            </Link>
            {
              <Link to="/manager/dashboard">
                <li>
                  <VscGraph size={17} />
                </li>
              </Link>
            }
            <Link to="/manager/orders">
              <li>
                <IoBag size={17} />
              </li>
            </Link>
            <Link to="/manager/history">
              <li>
                <IoTime size={17} />
              </li>
            </Link>
            <Link to="/manager/inventory">
              <li>
                <IoShirt size={17} />
              </li>
            </Link>
            <Link to="/manager/orders">
              <li>
                <IoNotifications size={17} />
              </li>
            </Link>
          </div>

          <div className="verified-sub-nav">
            <Link to="/manager/support">
              <li>
                <BiSupport size={17} />
              </li>
            </Link>
            <Link to="/manager/settings">
              <li>
                <IoIosSettings size={17} />
              </li>
            </Link>
            <Link to="/" onClick={handleLogout}>
              <li>
                <RiLogoutBoxFill size={17} />
              </li>
            </Link>
          </div>
        </ul>
      </nav>
    </header>
  );
};

export default VerifiedNavigation;
